import * as React from 'react';

import { IAgentInfo } from '@cian/api-models/favorites/types';

import { Text } from '../Text';

export interface IAgentProps {
  agentInfo: IAgentInfo;
}

export function Agent({ agentInfo }: IAgentProps) {
  const { name } = agentInfo;

  return (
    <Text textSize="small" color="black">
      {name}
    </Text>
  );
}
